import { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

import { Maintenance } from '@/components/templates/Maintenance.tsx'
import { useMaintenanceMode } from '@/hooks/useFeatureFlags.ts'
import { GlobalStyle } from '@/styles/globalStyles.tsx'
import { velthuis, xpert } from '@/styles/theme'
import { isVelthuis } from '@/utils/common.ts'

export const Providers = ({ children }: PropsWithChildren) => {
  const { isLoading, isMaintenanceMode } = useMaintenanceMode()
  const isBypassed =
    new URLSearchParams(window.location.search).get('bypass') === 'true'

  if (isLoading) {
    return (
      <ThemeProvider theme={isVelthuis ? velthuis : xpert}>
        <GlobalStyle />
      </ThemeProvider>
    )
  }

  if (isMaintenanceMode && !isBypassed) {
    return (
      <ThemeProvider theme={isVelthuis ? velthuis : xpert}>
        <GlobalStyle />
        <Maintenance />
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider theme={isVelthuis ? velthuis : xpert}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}
